import { useQuery } from '@tanstack/react-query';
import { medicalRecordsApi } from '@/api';

export function useCID10Search(query: string) {
  return useQuery({
    queryKey: ['cid10', 'search', query] as const,
    queryFn: () => medicalRecordsApi.searchCID10(query),
    enabled: query.length >= 3,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    retry: 2,
  });
}

export function useCID10ByCode(code: string) {
  return useQuery({
    queryKey: ['cid10', 'code', code] as const,
    queryFn: () => medicalRecordsApi.getCID10ByCode(code),
    enabled: !!code,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    retry: 2,
  });
}
